import { render, staticRenderFns } from "./TicketSlaTimer.vue?vue&type=template&id=85567b9c&scoped=true&"
import script from "./TicketSlaTimer.vue?vue&type=script&lang=js&"
export * from "./TicketSlaTimer.vue?vue&type=script&lang=js&"
import style0 from "./TicketSlaTimer.vue?vue&type=style&index=0&id=85567b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85567b9c",
  null
  
)

export default component.exports